// Should be overriden in you own project

export enum EnumEnvs {
  PRODUCTION = 'prod',
  BETA = 'beta',
  INTEGRATION = 'inte',
  LOCAL = 'local',
  PREVIEW = 'preview',
  TEST = 'test',
}

export interface IEnvironment {
  project?: string;
  production?: boolean;
  test?: boolean;
  env?: EnumEnvs;
  envDomain?: string;
  appPrefix?: string;
  clientIdMX?: string;
  clientIdC100X?: string;
  clientIdEasyKit?: string;
  clientIdC300XII?: string;

  myUrl?: string;
  wwwUrl?: string;
  authUrl?: string;
  appUrl?: string;
  apiUrl?: string;
  baseApiUrl?: string;
  oauth2ApiUrl?: string;
  syncApiUrl?: string;
  cookiePrefix?: string;
  webPusherUrl?: string;
  langsUrl?: string;
  helpcenterUrl?: string;
  legrandSupportUrl?: string;
  faqUrl?: string;
  showcaseUrl?: string;
  weatherMapUrl?: string;
  invitationUrl?: string;
  featureFlagApiUrl?: string;
  isProdDomain?: boolean;
  datadog?: {
    appId?: string;
    clientToken?: string;
  };
  COOKIE_LOCALE_DOMAIN?: string;
  cookieDomain?: string;
  settingsLegrandUrl?: string;
  settingsEnergyUrl?: string;
  settingsWeatherUrl?: string;
  settingsAircareUrl?: string;
  myAccountUrl?: string;
  termsAndCondtionsUrl?: string;
  webRTCSocketUrl?: string;
  turnUrl?: string;
  netatmoSiteUrl?: string;
  staticBlobUrl?: string;
  contentUrl?: string;
  logoutUrl?: string;
  prodApiUrl?: string;
  prodAppUrl?: string;
  shopUrl?: string;
  legalsUrl?: string;
  apiNewsUrl?: string;
  webappMode?: boolean;

  somfyClientId?: string;
  somfyRedirectUri?: string;
  aiChatEndpoint?: string;

  darkModeEnabled?: boolean;
  netatmoApiUrl?: string;
  netatmoBaseApiUrl?: string;
  netatmoOauth2Url?: string;
  netatmoSyncApiUrl?: string;
  eliotClientApi?: string;
  alexaClientId?: string;
  googleDeepLink?: string;
  alexaStage?: string;
  alexaRedirectUri?: string;
  postLoginUrl?: string;
  loginEliotUrl?: string;
  clientId?: string;
  privacyPolicyUrl?: string;
  appClientId?: string;
  alexaApp?: boolean;
  settings?: boolean;
  theme?: string;
}

export const environment: IEnvironment = {};
